module.exports = __webpack_public_path__ + "static/hero-2-bc7863007c28806bc77cbb15de2672db.png";